import React from 'react';
import { ArrowRightIcon, BellIcon } from 'lucide-react';
import { LoanCard } from './LoanCard';
import { loans } from '../data/loans';
export function CurrentInvestments() {
  return <section id="aktuelle-investeringer" aria-labelledby="aktuelle-title" className="scroll-mt-24 border-t border-ink/10 py-16 lg:py-24" data-id="element-1" data-mp="18uz5e7bhrjp6">
      <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-2" data-mp="1dmqm7q4uib24">
        <div className="max-w-2xl" data-id="element-3" data-mp="1ijh3uhwatepn">
          <h2 id="aktuelle-title" className="text-3xl font-bold tracking-tight text-ink lg:text-4xl" data-id="element-4" data-mp="1immpto9ms0h5">
            Aktuelle investeringer
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-5" data-mp="1rlzzoi1o2r2e">
            Herunder finder du lån, der aktuelt er tilgængelige på
            primærmarkedet – ideelt til din første investering. Vi har desuden et
            bredt udvalg af lån på sekundærmarkedet.
          </p>
        </div>
        <p className="text-sm font-semibold text-muted" data-id="element-6" data-mp="26irubzki61j">
          {loans.length} lån tilgængelige · opdateret i dag
        </p>
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-7" data-mp="1aa7o1yje1qfe">
        {loans.map(loan => <LoanCard key={loan.id} loan={loan} data-id="element-8" data-mp="16847ivhv3vn9" />)}

        <article className="flex h-full flex-col justify-between rounded-3xl bg-forest p-7 text-white" data-id="element-9" data-mp="168m6hzvwsnyv">
          <div data-id="element-10" data-mp="1176j4169e5db">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-lime text-forest" data-id="element-11" data-mp="1xzjsym7oncbw">
              <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-12" data-mp="1ty82yfkwcp36" />
            </span>
            <h3 className="mt-5 text-xl font-bold leading-snug" data-id="element-13" data-mp="1oyvexriahbz0">
              Nye lån bliver ofte fuldtegnet på få dage
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-white/70" data-id="element-14" data-mp="1jypizz4zl3b4">
              Listen her er et øjebliksbillede. Nye lån annonceres i vores mail
              til investorer – og de hurtigste får andelene. Er du ikke
              tilmeldt, opdager du dem typisk først, når de er væk.
            </p>
          </div>
          <a href="#nyhedsbrev" className="mt-8 inline-flex items-center gap-2 rounded-full bg-lime px-6 py-3.5 text-base font-bold text-forest transition-colors duration-150 ease-smooth hover:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime" data-id="element-15" data-mp="a2aobvba0c5x">
            Få besked om nye lån
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-16" data-mp="3nfmg4773key5" />
          </a>
        </article>
      </div>
    </section>;
}